import router from "@/router";
const isNotFound = (error) => error.response.status == 404;

const redirectToNotFoundPage = (error) => {
    router.push({ 
        name: 'PageNotFound', 
        params: { errorData: error?.response } 
    }).catch(() => {})
}

export { isNotFound, redirectToNotFoundPage }